@if (summary != null) { @switch (layout) { @case('INLINE') {
<div class="flight-documentation-summary-icons icon-summary">
    <span class="icon-summary-item">
        <i class="fal fa-plane-departure"></i>
        {{ summary['pre-flight'].total }}
    </span>
    <span class="icon-summary-item">
        <i class="fal fa-plane"></i>
        {{ summary.flying.total }}
    </span>
    <span class="icon-summary-item">
        <i class="fal fa-plane-arrival"></i>
        {{ summary['post-flight'].total }}
    </span>
</div>
} @case("EXPANDED") {
<div class="icon-summary-popover">
    <div class="icon-summary-popover-row">
        <span>Pre-flight</span>
        <span>
            {{ summary['pre-flight'].completed }} completed,
            {{ incomplete('pre-flight') }} incomplete
        </span>
    </div>
    <div class="icon-summary-popover-row">
        <span>Flying</span>
        <span>
            {{ summary.flying.completed }} completed,
            {{ incomplete('flying') }} incomplete
        </span>
    </div>
    <div class="icon-summary-popover-row">
        <span>Post-flight</span>
        <span>
            {{ summary['post-flight'].completed }} completed,
            {{ incomplete('post-flight') }} incomplete
        </span>
    </div>
</div>
} } }
